import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { computed } from "mobx";
import Result from "../../Core/Result";
import TerriaError from "../../Core/TerriaError";
import createStubCatalogItem from "../../Models/Catalog/createStubCatalogItem";
import upsertModelFromJson from "../../Models/Definition/upsertModelFromJson";
import Trait from "../Trait";
export default function modelReferenceTrait(options) {
  return function (target, propertyKey) {
    const constructor = target.constructor;
    if (!constructor.traits) {
      constructor.traits = {};
    }
    constructor.traits[propertyKey] = new ModelReferenceTrait(propertyKey, options, constructor);
  };
}
export class ModelReferenceTrait extends Trait {
  constructor(id, options, parent) {
    super(id, options, parent);
    _defineProperty(this, "decoratorForFlattened", computed.struct);
    _defineProperty(this, "factory", void 0);
    _defineProperty(this, "modelParentId", void 0);
    this.factory = options.factory;
    this.modelParentId = options.modelParentId;
  }
  getValue(model) {
    const strataTopToBottom = model.strataTopToBottom;
    for (const stratum of strataTopToBottom.values()) {
      const value = stratum[this.id];
      if (value !== undefined) {
        return value;
      }
    }
    return undefined;
  }
  fromJson(model, stratumName, jsonValue) {
    const errors = [];
    let result;
    if (typeof jsonValue === "string") {
      result = jsonValue;
    } else if (typeof jsonValue === "object") {
      if (this.factory === undefined) {
        errors.push(new TerriaError({
          title: "Cannot create Model",
          message: "A modelReferenceTrait does not have a factory but it contains an embedded model that does not yet exist."
        }));
      } else {
        var _newModel$uniqueId;
        const newModel = upsertModelFromJson(this.factory, model.terria, model.uniqueId === undefined ? this.modelParentId ? this.modelParentId : "/" : model.uniqueId, stratumName, jsonValue, {}).catchError(error => errors.push(error));
        result = (_newModel$uniqueId = newModel === null || newModel === void 0 ? void 0 : newModel.uniqueId) !== null && _newModel$uniqueId !== void 0 ? _newModel$uniqueId : createStubCatalogItem(model.terria).uniqueId;
      }
    } else {
      errors.push(new TerriaError({
        title: "Invalid property",
        message: "Elements of ".concat(this.id, " are expected to be strings or objects but instead are of type ").concat(typeof jsonValue, ".")
      }));
    }
    return new Result(result, TerriaError.combine(errors, "Error updating model \"".concat(model.uniqueId, "\" from JSON")));
  }
  toJson(value) {
    return value;
  }
  isSameType(trait) {
    return trait instanceof ModelReferenceTrait && trait.factory === this.factory;
  }
}